module.exports = __webpack_public_path__ + "static/media/6.40dd0588.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/6.png
// module id = 854
// module chunks = 0